<script setup>
// 히어로 — 반응형으로 옮긴 마지막 섹션.
//
// 원본: Figma 홈(ver1) 4133:20240 (1920x1009), 배경 #11100e
//   제목  y 245  (눈썹 "하이엔드 실물자산 플랫폼"(y 210, 22px)은 2026-09-23 삭제)  90px bold 흰색 행간 100 자간 -1.8  "Real Money is Real Gold"
//   설명  y 385 / 413  20px 흰색 행간 28, 두 줄
//   빛    y 820  두 덩이
//   카드 휠 y 521~  26장이 회전 각도로 배치됨
//
// 연출은 건드리지 않았다(이미 끝난 것으로 합의된 영역이다).
//   글은 아래에서 올라오는 역커튼(홈1-4), 카드 휠은 돌면서 올라와 아우라에서 멈춤(홈1-5).
//
// 원본에서 바꾼 것 — 글만이다.
//   절대좌표를 걷어내고 가운데 정렬 상자에 담았다. 글자는 원본 값 고정이고
//   제목만 clamp 로 감쌌다(1280 이상 원본 90px 고정).
//
// 빛과 카드 휠은 1920 좌표 그대로 둔 그림 층에 넣고 통째로 줄인다.
// 상한은 없다 — 1920 을 넘으면 그만큼 커져서 창 폭을 100% 채운다(토스와 같은 방식).
// 글자는 고정이고 그림만 채운다. 실측으로 토스도 메뉴 16px / 캡션 92px 이 2560·3840 에서
// 같고, 히어로 블록만 창 폭 100%(2550 -> 3830) 였다.
// 카드 26장이 회전 각도(HERO_WHEEL_*)로 배치돼 있어 좌표를 건드리면 배치가 무너진다.
//
// 그림 층은 521(1-배율)만큼 내려 놓는다. 글은 배율을 타지 않고 카드 휠은 타기 때문에,
// 그냥 두면 좁은 창에서 휠이 위로 올라와 글과 겹친다.
//   실제 휠 윗변 = 521(1-배율) + 521 x 배율 = 521  →  어느 배율에서도 글 아래 80px 에 선다.
import { computed, ref, onBeforeUnmount, onMounted } from 'vue'
import {
  HERO_WHEEL_EASING,
  HERO_WHEEL_END_DEG,
  HERO_WHEEL_ENTER_SHIFT,
  HERO_WHEEL_RISE_MS,
  HERO_WHEEL_SPIN_MS,
  HERO_WHEEL_START_DEG,
  TRANSITION_MS,
} from '@/data/homeMotionTiming.js'
import img17 from '@/assets/figma/2e5a98cc887dcecc7fa8875287b8b7ea1853de78.png'
import imgRotatedInstance2 from '@/assets/figma/7f372d8da4ebf9733add19253caff4f6d9973012.png'
import imgRotatedInstance3 from '@/assets/figma/d34f763655cec48f258c78ec143f3285bd0e5360.png'
import imgFrame2117923685 from '@/assets/figma/d0ce0f15c30a47089f5a533187e76b40e4875c0d.png'
import imgFrame2117923686 from '@/assets/figma/1928015760801cea315d284cee327af06fa5660b.png'
import imgFrame2117923687 from '@/assets/figma/eba6741617ec0cbf87ffc3eb656ec9b81b864c2b.png' // 아우라 — 카드가 여기서 멈춘다
import imgFrame2117923688 from '@/assets/figma/b74fb19b504aac05425fdb6a0192c8c5c27939ae.png'
import imgFrame2117923689 from '@/assets/figma/c1a08bcd161ad359b61af86a566dfee1c2c7d693.png'
import imgFrame2117923690 from '@/assets/figma/d8d94b3cfb2cb118cefad5c4b95e32cd4788fe44.png'
import imgFrame2117923691 from '@/assets/figma/2dc97862039b46a0463091c166b703de345779cf.png'
import imgFrame2117923692 from '@/assets/figma/d48617ff11bebe18c6dd78319dd22325aacda035.png' // 한국표준금거래소
import imgFrame2117923693 from '@/assets/figma/96cbce7e0468c282cde778494a55bd299d2c3d91.png'
import imgFrame2117923694 from '@/assets/figma/6cf2c17ca9943718b65ff1042b9f13b34925b724.png'
import imgEllipse30 from '@/assets/figma/79bde5abd6c276b96d29c3516f7ccf99d8c1a643.svg'
import imgEllipse31 from '@/assets/figma/a982b879af251030d7037d7d60d262700815d494.svg'
const style0 = { containerType: "size" }
const style1 = { containerType: "size" }
const style2 = { containerType: "size" }
const style3 = { containerType: "size" }
const style4 = { containerType: "size" }
const style5 = { containerType: "size" }
const style6 = { containerType: "size" }
const style7 = { containerType: "size" }
const style8 = { containerType: "size" }

const props = defineProps({
  // 현재 스토리보드 프레임 번호 (홈1-N)
  step: { type: Number, default: 5 },
})

const TRANSITION = TRANSITION_MS
const WHEEL_PIVOT = '960px 1644px'

// 1-1 검정 -> 1-2 배경 -> 1-3 메뉴 -> 1-4 히어로 글 -> 1-5 카드 휠
const bgOn = computed(() => props.step >= 2)
const textOn = computed(() => props.step >= 4)
const wheelIn = computed(() => props.step >= 5)

const wheelStyle = computed(() => ({
  transformOrigin: WHEEL_PIVOT,
  translate: wheelIn.value ? '0px 0px' : `0px ${HERO_WHEEL_ENTER_SHIFT}px`,
  rotate: `${wheelIn.value ? HERO_WHEEL_END_DEG : HERO_WHEEL_START_DEG}deg`,
  opacity: props.step >= 4 ? 1 : 0,
  transitionProperty: 'translate, rotate, opacity',
  transitionDuration: `${HERO_WHEEL_RISE_MS}ms, ${HERO_WHEEL_SPIN_MS}ms, ${TRANSITION}ms`,
  transitionTimingFunction: HERO_WHEEL_EASING,
}))

const glowStyle = computed(() => ({
  opacity: bgOn.value ? 1 : 0,
  transform: bgOn.value ? 'translateY(0)' : 'translateY(120px)',
  transitionDuration: `${TRANSITION}ms`,
}))

// 아래에서 위로 드러나는 역커튼. delay 로 순서를 준다.
const curtain = (delay) => ({
  transform: textOn.value ? 'translateY(0)' : 'translateY(110%)',
  transitionDuration: `${TRANSITION}ms`,
  transitionDelay: `${textOn.value ? delay : 0}ms`,
})

// ── 그림 층 배율 ─────────────────────────────────────────────────────
const DESIGN_W = 1920
const DESIGN_H = 1009
const WHEEL_TOP = 521

const root = ref(null)
const artScale = ref(1)
let observer = null

// 그림 배율에는 상한을 두지 않는다 — 토스처럼 배경이 창 폭을 100% 채운다.
// 휠과 빛에는 글자가 하나도 없어서(실측 0개) 키워도 글자가 커지는 문제가 없다.
// 다른 섹션의 그림(미디어 모자이크 9개, 20년 카드 24개, 비전 22개)은 안에 글자가 있어
// 여전히 1 에서 막아 둔다.
const measureArt = () => {
  const w = root.value?.clientWidth
  if (!w) return
  // 배율은 화면 뿌리(HomeSceneView)의 zoom 이 전담한다. 여기서 또 줄이면 두 번 줄어든다.
  artScale.value = 1
}

// 세로 리듬은 따로 1 에서 막는다. 그림 배율을 그대로 쓰면 3840 에서
// 제목 위 여백이 210 -> 420 으로 같이 늘어난다. 여백은 글에 딸린 값이다.
const rhythm = computed(() => Math.min(1, artScale.value))

// 그림 층을 내려 놓는 양. 어느 배율에서도 휠 윗변이 521 에 서게 한다.
const artTop = computed(() => WHEEL_TOP * (1 - artScale.value))
const sectionH = computed(() => artTop.value + DESIGN_H * artScale.value)

onMounted(() => {
  measureArt()
  observer = new ResizeObserver(measureArt)
  observer.observe(root.value)
})
onBeforeUnmount(() => {
  observer?.disconnect()
  observer = null
})
</script>

<template>
  <section
    ref="root"
    class="relative w-full overflow-hidden bg-[#11100e]"
    :style="{
      height: `${sectionH}px`,
      // 화면 높이를 채운다. 아래에 흰 바탕이 비치지 않아야 한다.
      // 100vh 는 걸린 배율만큼 커져 그려지므로 배율로 나눠 되돌린다. 배율이 둘이다 -
      // 화면 뿌리의 --z 와 이 섹션의 줄임 --fit. 둘 다 나눠야 줄인 뒤에도 정확히
      // 창 한 장이 된다(2026-09-26: 히어로도 한 화면 규칙 안으로 들어왔다).
      // 늘어난 만큼 빈 공간이 생기는 게 아니라 잘려 있던 카드 휠이 더 드러난다
      // (휠 전체는 캔버스 안에서 521~2767 이고, 그림 층은 자르지 않고 이 섹션이 자른다).
      minHeight: 'calc(100vh / (var(--z, 1) * var(--fit, 1)))',
      '--r': rhythm,
    }"
    data-node-id="4133:20240"
  >
    <!-- 그림 층. 빛과 카드 휠은 1920 좌표 그대로다. -->
    <div
      class="absolute left-1/2 origin-top"
      :style="{
        top: `${artTop}px`,
        width: `${DESIGN_W}px`,
        height: `${DESIGN_H}px`,
        transform: `translateX(-50%) scale(${artScale})`,
      }"
    >
        <div class="absolute h-[698px] left-[835px] top-[820px] w-[1533px] motion-ease" :style="glowStyle" data-node-id="4133:20250">
          <div class="absolute inset-[-42.98%_-19.57%]">
            <img alt="" class="block max-w-none size-full" :src="imgEllipse30" />
          </div>
        </div>
        <div class="absolute h-[698px] left-[-448px] top-[820px] w-[1601px] motion-ease" :style="glowStyle" data-node-id="4133:20251">
          <div class="absolute inset-[-42.98%_-18.74%]">
            <img alt="" class="block max-w-none size-full" :src="imgEllipse31" />
          </div>
        </div>
        <div class="absolute inset-0 will-change-transform" :style="wheelStyle" data-node-id="4133:20252">
          <div class="absolute h-[273px] left-[868px] top-[521px] w-[184px]" data-node-id="4133:20253" data-name="17">
            <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="img17" />
          </div>
          <div class="absolute flex h-[309.101px] items-center justify-center left-[1074.09px] top-[531.62px] w-[243.986px]" data-node-id="4133:20255">
            <div class="flex-none rotate-[13.85deg]">
              <div class="h-[273px] relative w-[184px]" data-name="Rotated Instance 2">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance2" />
                <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[273px] left-1/2 top-1/2 w-[184px]" data-node-id="4133:20256" />
              </div>
            </div>
          </div>
          <div class="absolute flex h-[327.239px] items-center justify-center left-[1273.55px] top-[606.88px] w-[289.793px]" data-node-id="4133:20257">
            <div class="flex-none rotate-[27.69deg]">
              <div class="h-[273px] relative w-[184px]" data-name="Rotated Instance 3">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance3" />
                <div class="-translate-x-1/2 -translate-y-1/2 absolute h-[273px] left-1/2 top-1/2 w-[184px]" data-node-id="4133:20258" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[73.58%_7.63%_-5.92%_75.77%] items-center justify-center" data-node-id="4133:20259" :style="style0">
            <div class="flex-none h-[hypot(-56.793cqw,62.6133cqh)] rotate-[41.54deg] w-[hypot(43.207cqw,37.3867cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923685" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[306.511px] items-center justify-center left-[calc(50%+811.87px)] top-[calc(50%+579.1px)] w-[329.199px]" data-node-id="4133:20260">
            <div class="flex-none rotate-[55.38deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923686" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[268.85px] items-center justify-center left-[calc(50%+922.4px)] top-[calc(50%+789.68px)] w-[320.507px]" data-node-id="4133:20261">
            <div class="flex-none rotate-[69.23deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923687" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[215.565px] items-center justify-center left-[calc(50%+979.31px)] top-[calc(50%+1020.59px)] w-[293.188px]" data-node-id="4133:20262">
            <div class="flex-none rotate-[83.08deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923688" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[215.565px] items-center justify-center left-[calc(50%+979.31px)] top-[calc(50%+1258.41px)] w-[293.188px]" data-node-id="4133:20263">
            <div class="flex-none rotate-[96.92deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923689" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[268.85px] items-center justify-center left-[calc(50%+922.4px)] top-[calc(50%+1489.32px)] w-[320.507px]" data-node-id="4133:20264">
            <div class="flex-none rotate-[110.77deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923690" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[203.28%_-0.86%_-133.66%_83.71%] items-center justify-center" data-node-id="4133:20265" :style="style1">
            <div class="flex-none h-[hypot(-68.249cqw,-50.5958cqh)] rotate-[124.62deg] w-[hypot(-31.751cqw,49.4042cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923691" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[326.358px] items-center justify-center left-[calc(50%+654.17px)] top-[calc(50%+1877.91px)] w-[318.758px]" data-node-id="4133:20266">
            <div class="flex-none rotate-[138.46deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923692" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[233.29%_18.58%_-165.72%_66.33%] items-center justify-center" data-node-id="4133:20267" :style="style2">
            <div class="flex-none h-[hypot(-43.7793cqw,-73.8695cqh)] rotate-[152.31deg] w-[hypot(-56.2207cqw,26.1305cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923693" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[309.101px] items-center justify-center left-[calc(50%+236.08px)] top-[calc(50%+2097.34px)] w-[243.986px]" data-node-id="4133:20268">
            <div class="flex-none rotate-[166.15deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923694" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[247.18%_45.21%_-174.23%_45.21%] items-center justify-center" data-node-id="4133:20269" :style="style3">
            <div class="flex-none h-[100cqh] rotate-180 w-[100cqw]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="img17" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[309.101px] items-center justify-center left-[calc(50%-236.08px)] top-[calc(50%+2097.33px)] w-[243.986px]" data-node-id="4133:20270">
            <div class="flex-none rotate-[-166.15deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance2" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[327.239px] items-center justify-center left-[calc(50%-458.45px)] top-[calc(50%+2013px)] w-[289.793px]" data-node-id="4133:20271">
            <div class="flex-none rotate-[-152.31deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgRotatedInstance3" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[219.94%_75.77%_-152.29%_7.63%] items-center justify-center" data-node-id="4133:20272" :style="style4">
            <div class="flex-none h-[hypot(56.793cqw,-62.6133cqh)] rotate-[-138.46deg] w-[hypot(-43.207cqw,-37.3867cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923685" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[306.511px] items-center justify-center left-[calc(50%-811.87px)] top-[calc(50%+1699.9px)] w-[329.199px]" data-node-id="4133:20273">
            <div class="flex-none rotate-[-124.62deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923686" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[268.85px] items-center justify-center left-[calc(50%-922.4px)] top-[calc(50%+1489.32px)] w-[320.507px]" data-node-id="4133:20274">
            <div class="flex-none rotate-[-110.77deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923687" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[215.565px] items-center justify-center left-[calc(50%-979.31px)] top-[calc(50%+1258.41px)] w-[293.188px]" data-node-id="4133:20275">
            <div class="flex-none rotate-[-96.92deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923688" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[215.565px] items-center justify-center left-[calc(50%-979.31px)] top-[calc(50%+1020.59px)] w-[293.188px]" data-node-id="4133:20276">
            <div class="flex-none rotate-[-83.08deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923689" />
              </div>
            </div>
          </div>
          <div class="-translate-x-1/2 -translate-y-1/2 absolute flex h-[268.85px] items-center justify-center left-[calc(50%-922.4px)] top-[calc(50%+789.68px)] w-[320.507px]" data-node-id="4133:20277">
            <div class="flex-none rotate-[-69.23deg]">
              <div class="h-[273px] relative w-[184px]">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923690" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[92.2%_83.71%_-22.58%_-0.86%] items-center justify-center" data-node-id="4133:20278" :style="style5">
            <div class="flex-none h-[hypot(68.249cqw,50.5958cqh)] rotate-[-55.38deg] w-[hypot(31.751cqw,-49.4042cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923691" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[73.58%_75.77%_-5.92%_7.63%] items-center justify-center" data-node-id="4133:20279" :style="style6">
            <div class="flex-none h-[hypot(56.793cqw,62.6133cqh)] rotate-[-41.54deg] w-[hypot(43.207cqw,-37.3867cqh)]">
              <div class="relative rounded-[20px] size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[20px] size-full" :src="imgFrame2117923692" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[60.15%_66.33%_7.42%_18.58%] items-center justify-center" data-node-id="4133:20280" :style="style7">
            <div class="flex-none h-[hypot(43.7793cqw,73.8695cqh)] rotate-[-27.69deg] w-[hypot(56.2207cqw,-26.1305cqh)]">
              <div class="relative size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none size-full" :src="imgFrame2117923693" />
              </div>
            </div>
          </div>
          <div class="absolute flex inset-[52.69%_55.94%_16.68%_31.35%] items-center justify-center" data-node-id="4133:20281" :style="style8">
            <div class="flex-none h-[hypot(26.7774cqw,85.7542cqh)] rotate-[-13.85deg] w-[hypot(73.2226cqw,-14.2458cqh)]">
              <div class="relative rounded-[20px] size-full">
                <img alt="" class="absolute inset-0 max-w-none object-cover pointer-events-none rounded-[20px] size-full" :src="imgFrame2117923694" />
              </div>
            </div>
          </div>
        </div>
    </div>

    <!-- 글. 화면 뿌리의 zoom 을 같이 탄다(2026-09-25). -->
    <div class="relative mx-auto w-full max-w-[1690px] px-[20px] pt-[210px] text-center">
      <div class="overflow-hidden">
        <p class="hero-title motion-ease" :style="curtain(100)">Real Money is Real Gold</p>
      </div>
      <div class="mt-[40px] overflow-hidden">
        <p class="hero-sub motion-ease" :style="curtain(220)">금과 은을 통해 시장의 흐름을 넘어,</p>
      </div>
      <div class="overflow-hidden">
        <p class="hero-sub motion-ease" :style="curtain(300)">
          시간이 지나도 변하지 않는 가치 그 자체를 거래합니다.
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped>

/* 제목은 그림(로고카드)과 같은 비율로 줄어든다. 그림이 창폭/1920 으로 줄어드니
   글자도 90/1920*100 = 4.6875vw 로 잡는다. 1920 을 넘으면 원본 90px 에 걸린다.
   (90 / 1280 * 100 = 7.03vw) */
.hero-title {
  margin: 0;
  font-size: 90px;
  line-height: 1.111;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fff;
  white-space: nowrap;
}

.hero-sub {
  margin: 0;
  font-size: 20px;
  line-height: 28px;
  color: #fff;
  word-break: keep-all;
}
</style>
